import { render } from "./App.vue?vue&type=template&id=4b9a18c4"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=4b9a18c4&lang=css"

import exportComponent from "/Users/mhall/dev/rorserver/newcomb/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__